import dotenv from 'dotenv'
import Vue from 'vue'
import VueRouter from 'vue-router'
import CampaignCleanup from '../views/CampaignCleanup'
import CampaignNotFound from '../views/CampaignNotFound'
import CampaignsList from '../views/CampaignsList'
import CampaignDesigner from '../views/CampaignDesigner'
import CampaignMonitor from '../views/CampaignMonitor'
import DomainTablesConfiguration from '../views/DomainTablesConfiguration'
import ExclusionRules from '../views/ExclusionRules'
import FastCounter from '../views/FastCounter'
import PreviewConfiguration from '../views/PreviewConfiguration'
import JobsViewer from '../views/JobsViewer'
import Logout from '../views/Logout'
import OffersViewer from '../views/OffersViewer'
import PageNotFound from '../views/PageNotFound'
import SendingRules from '../views/SendingRules'
import SectionNotFound from '../views/SectionNotFound'
import Unauthorized from '../views/Unauthorized'
import UsersManagement from '../views/UsersManagement'

dotenv.config()

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    component: PageNotFound
  },
  {
    path: '/page-not-found',
    component: PageNotFound
  },
  {
    path: '/',
    redirect: '/campaigns'
  },
  {
    path: '/campaigns',
    name: 'Campaign Designer',
    component: CampaignsList
  },
  {
    path: '/campaigns/new',
    name: 'New Campaign',
    component: CampaignDesigner
  },
  {
    path: '/campaigns/:id',
    name: 'View Campaign',
    component: CampaignDesigner,
    props: (route) => ({
      campaignId: route.params.id
    })
  },
  {
    path: '/campaigns/:id/:step',
    name: 'View Campaign',
    component: CampaignDesigner,
    props: (route) => ({
      campaignId: route.params.id,
      step: route.params.step
    })
  },
  {
    path: '/preview',
    name: 'Fast Counter',
    component: FastCounter
  },
  {
    path: '/preview/new',
    name: 'New Preview',
    component: PreviewConfiguration
  },
  {
    path: '/preview/:id',
    name: 'View Preview',
    component: PreviewConfiguration,
     props: (route) => ({
      previewId: route.params.id,
    })
  },
  {
    path: '/preview/:id/:step',
    name: 'View Preview',
    component: PreviewConfiguration,
     props: (route) => ({
      previewId: route.params.id,
      step: route.params.step
    })
  },
  {
    path: '/campaign-not-found',
    component: CampaignNotFound
  },
  {
    path: '/sectionNotFound/:recordId',
    component: SectionNotFound,
    props: true
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout
  },
  {
    path: '/monitoring',
    name: 'Campaign Monitoring',
    component: CampaignMonitor
  },
  {
    path: '/executionrules/exclusionrules',
    name: 'Exclusion Rules',
    component: ExclusionRules
  },
  {
    path: '/executionrules/sendingrules',
    name: 'Sending Rules',
    component: SendingRules
  },
  {
    path: '/users',
    name: 'User Management',
    component: UsersManagement
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: Unauthorized
  },
  {
    path: '/jobsViewer',
    component: JobsViewer
  },
  {
    path: '/table-config',
    component: DomainTablesConfiguration
  },
  {
    path: '/clean-it',
    component: CampaignCleanup
  },
  {
    path: '/clean-it/:id',
    component: CampaignCleanup,
    props: (route) => ({
      id: route.params.id
    })
  },
  {
    path: '/offers-viewer',
    component: OffersViewer
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
